(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qm-home-showcase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qm-category-showcase')) {
  customElements.define('qm-category-showcase', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('[data-qm-slide]'));
      this.selectors = Array.from(this.querySelectorAll('[data-qm-select]'));
      this.current = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      
      this.editorBlockId = null;
      this.focused = false;
      this.inView = false;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 10000);
      this.toggle = this.querySelector('[data-qm-toggle]');
      this.counter = this.querySelector('[data-qm-current]');
      this.progress = this.querySelector('[data-qm-progress]');
      this.selectors.forEach((button, index) => button.addEventListener('click', () => this.show(index, true), { signal }));
      this.querySelector('[data-qm-prev]')?.addEventListener('click', () => this.show(this.current - 1, true), { signal });
      this.querySelector('[data-qm-next]')?.addEventListener('click', () => this.show(this.current + 1, true), { signal });
      this.toggle?.addEventListener('click', () => { const paused = this.userPaused || Boolean(this.editorBlockId); this.editorBlockId = null; this.userPaused = !paused; this.sync(); this.schedule(); }, { signal });
      this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.schedule(); }, { signal });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.userPaused = true; this.sync(); this.schedule(); }, { signal });
      this.querySelector('.qm-showcase__navigation')?.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
        this.selectors[this.current]?.focus({ preventScroll: true });
      }, { signal });
      const panels = this.querySelector('.qm-showcase__panels');
      panels?.addEventListener('touchstart', event => { this.touchStart = [event.touches[0].clientX, event.touches[0].clientY]; }, { passive:true, signal });
      panels?.addEventListener('touchend', event => {
        if (!this.touchStart) return;
        const dx = event.changedTouches[0].clientX - this.touchStart[0];
        const dy = event.changedTouches[0].clientY - this.touchStart[1];
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          if (event.cancelable) event.preventDefault();
          this.show(this.current + (dx < 0 ? 1 : -1), true);
        }
      }, { passive:false, signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.editorBlockId = event.detail.blockId; this.show(index); }
      }, { signal });
      document.addEventListener('shopify:block:deselect', event => {
        if (event.detail?.blockId !== this.editorBlockId) return;
        this.editorBlockId = null;
        this.sync();
        this.schedule();
      }, { signal });
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        this.editorBlockId = null;
        this.sync();
        this.schedule();
      }, { signal });
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].intersectionRatio >= 0.15; this.schedule(); }, { threshold:0.15 });
      this.observer.observe(this);
      this.classList.add('is-enhanced');
      this.show(0);
    }
    show(index, manual = false) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      if (manual) this.editorBlockId = null;
      // Manual navigation restarts autoplay unless the shopper explicitly paused it.
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.current;
        slide.inert = i !== this.current;
        slide.classList.toggle('is-active', i === this.current);
      });
      this.selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.current)));
      const navigation = this.querySelector('.qm-showcase__navigation');
      const activeButton = this.selectors[this.current];
      if (navigation && activeButton && navigation.scrollWidth > navigation.clientWidth) {
        const left = navigation.scrollLeft + activeButton.getBoundingClientRect().left - navigation.getBoundingClientRect().left - (navigation.clientWidth - activeButton.offsetWidth) / 2;
        navigation.scrollTo({ left, behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }
      if (this.counter) this.counter.textContent = String(this.current + 1).padStart(2, '0');
      [this.current, (this.current + 1) % this.slides.length].forEach(i => this.slides[i].querySelectorAll('img').forEach(img => { img.loading = 'eager'; }));
      this.sync();
      this.schedule();
    }
    sync() {
      if (!this.toggle) return;
      const paused = this.userPaused || Boolean(this.editorBlockId);
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.querySelector('[data-qm-toggle-icon]').textContent = paused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      this.progressAnimation?.cancel();
      const running = this.slides.length > 1 && !this.userPaused && !this.editorBlockId && !this.focused && this.inView && !document.hidden;
      this.dataset.running = String(running);
      if (!running) return;
      this.timer = setTimeout(() => this.show(this.current + 1), this.interval);
      if (!this.reduced.matches && this.progress?.animate) {
        this.progressAnimation = this.progress.animate(
          [{ transform:'scaleX(0)' }, { transform:'scaleX(1)' }],
          { duration:this.interval, easing:'linear', fill:'forwards' }
        );
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.progressAnimation?.cancel();
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
